import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        // Use the enhanced API endpoint that includes post counts
        const response = await axios.get('/api/categories/with-counts');
        setCategories(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching categories:', err);
        setError('Failed to load categories. Please try again later.');
        setLoading(false);
        
        // No fallback to simulated data - we want to show the real error
      }
    };
    
    fetchCategories();
  }, []);
  
  if (loading) {
    return (
      <>
        <Header />
        <div className="container mx-auto py-12">
          <div className="flex justify-center items-center h-64">
            <div className="spinner"></div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  
  if (error) {
    return (
      <>
        <Header />
        <div className="container mx-auto py-12">
          <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
            <p className="text-red-700">{error}</p>
          </div>
          <div className="text-center mt-8">
            <button 
              onClick={() => window.location.reload()}
              className="btn btn-primary"
            >
              Try Again
            </button>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  
  return (
    <>
      <Header />
      
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-secondary-800 font-heading">Categories</h1>
            <div className="w-16 h-1 bg-primary-500 mx-auto mt-4"></div>
            <p className="text-secondary-600 max-w-2xl mx-auto mt-4">Browse our articles by topic to find the insights you're looking for</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.length > 0 ? (
              categories.map(category => (
                <Link 
                  key={category._id} 
                  to={`/categories/${category.name}`}
                  className="category-card group"
                >
                  <div className="category-card-content">
                    <h2 className="category-card-title">{category.name}</h2>
                    {category.description && (
                      <p className="category-card-description">{category.description}</p>
                    )}
                    <div className="flex justify-between items-center mt-4">
                      <span className="category-card-link">
                        Browse Articles
                        <svg className="w-4 h-4 ml-1 inline-block transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                        </svg>
                      </span>
                      <span className="category-card-count">{category.count} {category.count === 1 ? 'post' : 'posts'}</span>
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              <div className="col-span-3 text-center py-12">
                <p className="text-gray-500">No categories found. Create some categories in the admin dashboard.</p>
              </div>
            )}
          </div>
          
          <div className="text-center mt-12">
            <Link to="/" className="btn btn-outline">Back to Home</Link>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default CategoryList;
